<template>
  <div class="q-mb-lg">
    <div
      class="bg-green-1 q-py-xs q-px-sm cursor-pointer"
      data-test="card-heading"
      @click="toggleCollapsed"
    >
      <div class="group-heading">{{ groupHeading }}</div>
      <div class="text-body2">{{ `${rows.length} ${t('data.item', rows.length)}` }}</div>
    </div>
    <div v-if="!isCollapsed" class="row items-start q-py-md q-gutter-md justify-center">
      <!-- TODO: Use some sort of unique identifier for the rows as the key attribute -->
      <q-card
        v-for="row in rows"
        :key="row"
        class="cursor-pointer q-pa-md column items-start width--third no-wrap overflow-hidden"
        data-test="card"
        style="height: 200px"
        @click="openModal(row)"
      >
        <q-card-section v-for="(cell, key) in row" :key="key" class="q-pa-xs">
          <div class="text-grey-6">{{ columns[key].label[localeString] }}</div>
          <table-cell-render
            :data="cell.toString()"
            :data-type="returnCellType(key.toString())"
            :filter="filter"
          ></table-cell-render>
        </q-card-section>
      </q-card>
    </div>
  </div>
  <q-dialog v-model="inspectData">
    <q-card class="q-pa-md modal">
      <q-card-section class="row items-center q-pa-none">
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>
      <div style="max-height: 250px" class="row">
        <q-card-section v-for="(cell, key) in selectedRow" class="col-4">
          <div class="text-grey-6">{{ columns[key].label[localeString] }}</div>
          <table-cell-render
            :data="cell.toString()"
            :data-type="returnCellType(key.toString())"
            :filter="filter"
            :word-wrap="true"
          ></table-cell-render>
        </q-card-section>
      </div>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue'
import { ColumnsInterface, DataRow } from '../types/components/data-rendering'
import TableCellRender from './TableCellRender.vue'
import { SortingKeyType } from '../composables/sortAlgorithm'
import { useI18n } from 'vue-i18n'
import { LanguageChoice } from '../i18n'

export default defineComponent({
  props: {
    // Columns for the data
    columns: {
      type: Object as PropType<ColumnsInterface>,
      required: true,
    },
    // Rows for the group of data
    rows: {
      type: Array as PropType<DataRow[]>,
      required: true,
    },
    // Value of the search filter
    filter: {
      required: false,
      type: String as PropType<string | null>,
      default: null,
    },
    // Expand or hide the table data, excluding the heading
    collapsed: {
      default: true,
      type: Boolean as PropType<boolean>,
    },
    // The group heading name
    groupHeading: {
      required: false,
      type: String as PropType<string>,
      default: 'All Data',
    },
  },
  components: {
    TableCellRender,
  },
  setup(props) {
    const { locale, t } = useI18n({ useScope: 'global' })
    const localeString = computed(() => locale.value as LanguageChoice)

    const isCollapsed = ref(props.collapsed)
    function toggleCollapsed() {
      isCollapsed.value = !isCollapsed.value
    }

    const returnCellType = (key: string): SortingKeyType =>
      props.columns[key].type as SortingKeyType

    const inspectData = ref(false)
    const selectedRow = ref<DataRow | null>(null)
    function openModal(row: DataRow): void {
      selectedRow.value = row
      inspectData.value = true
    }
    return {
      returnCellType,
      localeString,
      t,
      isCollapsed,
      toggleCollapsed,
      openModal,
      inspectData,
      selectedRow,
    }
  },
})
</script>

<style scoped>
.group-heading {
  font-size: 13px;
}
.width--third {
  width: calc(100% - 66% - 32px);
}
.modal {
  max-width: 60%;
  max-height: 80%;
}
.relative {
  position: relative;
}
</style>
